class r extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.setUpObservers();
  }
  init() {
    window.customElements.get("swiper-container") || (async () => await import("./chunk-swiper-element-bundle-Bk-3iR66.js").then((s) => {
      const { register: e } = s;
      e();
    }))();
  }
  setUpObservers() {
    const s = {
      root: null,
      threshold: 0.1
    }, e = new IntersectionObserver((t) => {
      t.forEach((n) => {
        n.isIntersecting && (this.init(), e.disconnect());
      });
    }, s);
    e.observe(this);
  }
}
window.customElements.get("swiper-base") || window.customElements.define("swiper-base", r);
